module.exports = __webpack_public_path__ + "img/subm.d2aa975e.png";